// extracted by mini-css-extract-plugin
export var growableInput = "_3c-0";
export var tagContainer = "_3c-2";
export var textInput = "_3c-1";